import VisibilityIcon from "@mui/icons-material/Visibility";
import { Typography } from "@mui/material";
import { debtsRequests } from "api/debtsApi";
import { settings } from "app";
import { useState } from "react";
import { Button, Datagrid, DateField, FunctionField, TextField, useRecordContext } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { TransactionStatuses } from "utils/constants";
import { useNotifyError } from "utils/useNotifyError";

const DebtTransactionsDialog = () => {
  const record = useRecordContext();
  const notifyError = useNotifyError();
  const [transactions, setTransactions] = useState([]);

  const onOpen = async () => {
    try {
      const { data } = await dataProvider.customRequest(debtsRequests.getDebtTransactions(record?.id), null, "GET");
      setTransactions(data || []);
    } catch (err) {
      notifyError(err);
      return false;
    }
  };

  return (
    <ConfirmModal
      titleContent="Детайли за плащането"
      dialogSize="md"
      isConfirmButton={false}
      closeTitle="Затвори"
      onOpen={onOpen}
      resetProps={() => setTransactions([])}
      triggerButton={
        <Button
          label="Детайли"
          startIcon={<VisibilityIcon />}
          size="small"
        />
      }
    >
      <Datagrid
        data={transactions}
        rowClick={false}
        bulkActionButtons={false}
        resource="debtTransactions"
        empty={<Typography sx={{ p: 2 }}>Няма транзакции</Typography>}
        sx={settings.style.secondaryDatagrid}
      >
        <TextField
          label="ID"
          source="id"
          emptyText="-"
          sortable={false}
        />
        <TextField
          label="Референция"
          source="referenceId"
          emptyText="-"
          sortable={false}
        />
        <TextField
          label="Канал"
          source="providerName"
          emptyText="-"
          sortable={false}
        />
        <FunctionField
          label="Сума"
          sortable={false}
          render={rec => `${rec?.amountFormatted ?? rec?.amount?.toFixed(2) ?? "-"} ${rec?.currency ?? ""}`}
        />
        <FunctionField
          label="Статус"
          sortable={false}
          render={rec => TransactionStatuses[rec?.status] || rec?.status}
        />
        <DateField
          label="Платено на"
          source="paymentTimestamp"
          locales="bg-BG"
          showTime
          emptyText="-"
          sortable={false}
        />
        <TextField
          label="Описание"
          source="description"
          emptyText="-"
          sortable={false}
        />
      </Datagrid>
    </ConfirmModal>
  );
};

export default DebtTransactionsDialog;
